export const easeInOutQuad = (t, b, c, d) => {
    if ((t /= d / 2) < 1) { 
        return (c / 2) * t * t + b;
    }
    return (-c / 2) * (--t * (t - 2) - 1) + b;
};

export const easeInCirc = (t, b, c, d) => {
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
};

export const easeInOutCubic = (t, b, c, d) => {
    if ((t /= d / 2) < 1) {
        return c / 2 * t * t * t + b;
    } else {
        return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
}

export class Easing {
    public currentValues: Array<number>;
    private startTime: number;

    public complete = false;

    constructor(
        public startValues: Array<number>,
        public endValues: Array<number>,
        public duration: number,
        public transition: Function = easeInOutQuad
    ) {
        this.startTime = Date.now();
        this.currentValues = this.startValues.slice(0);
    }

    public onComplete?: Function; //TODO: need type, Function is bad practice
    public onStep?: Function;

    public clear() {
        this.onComplete = undefined;
        this.onStep = undefined;
    }

    public update(time: number) {
        const currentTime = Date.now();

        let elapsed = (currentTime - this.startTime) / this.duration;
        elapsed = this.duration === 0 || elapsed > 1 ? 1 : elapsed;

        if (elapsed === 1) {
            this.complete = true;
            this.currentValues = this.endValues.slice(0);

            if (this.onStep) {
                this.onStep(this.currentValues);
            }
            if (this.onComplete) {
                this.onComplete();
            }
        } else {
            for (let i = 0; i < this.startValues.length; i++) {
                this.currentValues[i] = this.transition(
                    currentTime - this.startTime,
                    this.startValues[i],
                    this.endValues[i] - this.startValues[i],
                    this.duration
                );
            }

            if (this.onStep) {
                this.onStep(this.currentValues);
            }
        }
    }
}
